import type { FC } from "react";

import styled from "styled-components";

import { SWReactIcons } from "@similarweb/icons";

import {
    NoData as DefaultNoData,
    type INoDataProps as IDefaultNoDataProps,
} from "app/pages/keyword-analysis/TotalTrafficPage/Components/UtilityComponents";

import { FlexColumn, FlexRow } from "../../../styled components/StyledFlex/src/StyledFlex";
import WithTranslation from "../../WithTranslation/src/WithTranslation";

export const NoDataIcon: any = styled(SWReactIcons)`
    height: 90px;
    width: 194px;
    margin-bottom: 32px;
`;

NoDataIcon.displayName = "NoDataIcon";

export const NoDataTitle = styled.div<{ size?: number | string }>`
    font-size: ${({ size }) => (typeof size === "string" ? size : `${size}px`)};
    letter-spacing: 0.2px;
    margin-bottom: 24px;
    color: rgba(42, 62, 82, 0.6);
    text-align: center;
    font-weight: 500;
    max-width: 74%;
`;
NoDataTitle.displayName = "NoDataTitle";

export const NoDataSubtitle = styled(NoDataTitle)`
    font-size: 14px;
    letter-spacing: 0.1;
    margin: 0;
`;
NoDataSubtitle.displayName = "NoDataSubtitle";

const NoDataContainer: any = styled(FlexColumn)`
    height: 100%;
    align-items: center;
    justify-content: center;
    padding: 0 8px;
    font-family: Roboto;
`;
NoDataContainer.displayName = "NoDataContainer";

const NoDataLandscapeTitleContainer: any = styled(FlexRow)`
    align-items: flex-end;
    margin-bottom: 16px;
    ${NoDataIcon} {
        height: 24px;
        width: 24px;
        margin-bottom: 0;
        margin-right: 8px;
    }
    ${NoDataTitle} {
        margin-bottom: 0;
    }
`;
NoDataLandscapeTitleContainer.displayName = "NoDataLandscapeTitleContainer";

const NoDataRowContainer = styled(FlexRow)`
    ${NoDataSubtitle} {
        text-align: left;
        padding: 0px 0px 0px 10px;
        align-self: center;
    }
    ${NoDataIcon} {
        width: 32px;
        height: 32px;
        padding-top: 3px;
        margin-bottom: 0px;
    }
`;
NoDataRowContainer.displayName = "NoDataRowContainer";

const DefaultNoDataLayoutContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
`;

const noDataDefaultProps = {
    iconName: "no-data-lab",
    title: "global.nodata.notavilable",
    subtitle: "global.nodata.notavilable.subtitle",
};

type NoDataProps = {
    title?: string;
    subtitle?: string;
    iconName?: string;
    SvgImage?: any;
    className?: string;
    titleSize?: number | string;
};

export const NoData: FC<NoDataProps> = ({
    title = noDataDefaultProps.title,
    subtitle = noDataDefaultProps.subtitle,
    iconName = noDataDefaultProps.iconName,
    SvgImage,
    className,
    titleSize,
}) => (
    <WithTranslation>
        {(translate) => (
            <NoDataContainer
                className={className}
                data-automation="no-data-wrapper"
            >
                {SvgImage ? <SvgImage /> : <NoDataIcon iconName={iconName} />}
                <NoDataTitle
                    data-automation-title-name="no-result-title"
                    size={titleSize}
                >
                    {translate(title)}
                </NoDataTitle>
                {subtitle ? (
                    <NoDataSubtitle data-automation-subtitle-name="no-result-subtitle">
                        {translate(subtitle)}
                    </NoDataSubtitle>
                ) : null}
            </NoDataContainer>
        )}
    </WithTranslation>
);

export interface INoDataLandscapeProps {
    subtitle?: IDefaultNoDataProps["noDataSubTitleKey"];
    title?: IDefaultNoDataProps["noDataSubTitleKey"];
}

export const NoDataLandscape = ({
    title = noDataDefaultProps.title,
    subtitle = noDataDefaultProps.subtitle,
}: INoDataLandscapeProps) => (
    <DefaultNoDataLayoutContainer>
        <DefaultNoData
            noDataTitleKey={title}
            noDataSubTitleKey={subtitle}
        />
    </DefaultNoDataLayoutContainer>
);

const NoDataRow = ({
    description,
    iconName = noDataDefaultProps.iconName,
}: {
    description: string;
    iconName?: string;
}) => (
    <WithTranslation>
        {(translate) => (
            <NoDataContainer>
                <NoDataRowContainer>
                    <NoDataIcon iconName={iconName} />
                    <NoDataSubtitle>{translate(description)}</NoDataSubtitle>
                </NoDataRowContainer>
            </NoDataContainer>
        )}
    </WithTranslation>
);
